
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"#737791"}},[_c('path',{attrs:{"d":"M21.125 3.24h-7.1V1.708A1.71 1.71 0 0012.32 0h-1.163A1.71 1.71 0 009.45 1.707V3.24H2.375A2.375 2.375 0 000 5.615v11.033a2.375 2.375 0 002.375 2.375h18.75a2.375 2.375 0 002.375-2.375V5.615a2.375 2.375 0 00-2.375-2.374zm-10.29-1.533c0-.198.148-.346.346-.346h1.163c.198 0 .346.148.346.346v2.671a.338.338 0 01-.346.347H11.18a.338.338 0 01-.346-.347V1.707zm11.305 14.94c0 .57-.47 1.015-1.015 1.015H2.375c-.57.025-1.014-.445-1.014-1.014V5.615c0-.569.47-1.014 1.014-1.014h7.149c.123.816.791 1.484 1.657 1.484h1.163c.866 0 1.533-.643 1.657-1.484h7.124c.57 0 1.015.445 1.015 1.014v11.033z"}}),_c('path',{attrs:{"d":"M19.146 7.693h-6.703a.665.665 0 00-.668.668c0 .371.297.668.668.668h6.704a.665.665 0 00.667-.668.665.665 0 00-.668-.668zm0 3.142h-6.703a.665.665 0 00-.668.668c0 .37.297.668.668.668h6.704a.665.665 0 00.667-.668.665.665 0 00-.668-.668zm0 3.117h-6.703a.665.665 0 00-.668.668c0 .37.297.667.668.667h6.704a.665.665 0 00.667-.667.665.665 0 00-.668-.668zm-10.76-2.326a.413.413 0 00-.297.025 2.937 2.937 0 01-1.237.297 2.61 2.61 0 01-1.237-.297.413.413 0 00-.296-.025 1.898 1.898 0 00-1.386 1.46l-.346 1.558a1.07 1.07 0 001.039 1.311h4.502a1.07 1.07 0 001.039-1.31l-.346-1.56a2.082 2.082 0 00-1.435-1.459zm-1.534-.519a2.028 2.028 0 100-4.057 2.028 2.028 0 000 4.057z"}})])])
          )
        }
      }
    